module.exports = __webpack_public_path__ + "img/camparisoda.e61c6925.jpg";